/** Add a run credential: any named secret an agent needs inside a run. The value is sent once and never shown again — only its hint. */

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/ui/field";
import { Dialog } from "@/components/ui/overlay";
import { errorText } from "@/components/ui/states";
import { useCreateCredential } from "@/features/credentials/hooks";
import { useUiStore } from "@/stores/ui-store";

export function AddCredentialDialog({ onClose }: { onClose: () => void }) {
  const [name, setName] = useState("");
  const [value, setValue] = useState("");
  const create = useCreateCredential();
  const notify = useUiStore((s) => s.notify);
  const submit = () =>
    create.mutate(
      { name: name.trim(), value },
      {
        onSuccess: (c) => (notify(`Saved ${c.name}.`), onClose()),
        onError: (e) => notify(errorText(e, "Could not save the credential."), "error"),
      },
    );
  return (
    <Dialog
      title="Add run credential"
      subtitle="A secret the agent needs inside a run. Encrypted, and never shown again."
      onClose={onClose}
      width={520}
      footer={
        <>
          <span className="flex-1" />
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="primary" disabled={!name.trim() || !value || create.isPending} onClick={submit}>
            Save credential
          </Button>
        </>
      }
    >
      <Field label="Name" required htmlFor="credential-name" hint="For example “MedStar EMR sandbox”.">
        <input id="credential-name" className="inp" value={name} onChange={(e) => setName(e.target.value)} />
      </Field>
      <Field
        label="Value"
        required
        htmlFor="credential-value"
        hint="Only the last four characters are kept for display."
      >
        <input
          id="credential-value"
          type="password"
          autoComplete="off"
          className="inp font-mono"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </Field>
    </Dialog>
  );
}
